import { render, staticRenderFns } from "./401.vue?vue&type=template&id=49493022"
import script from "./401.vue?vue&type=script&lang=js"
export * from "./401.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49493022')) {
      api.createRecord('49493022', component.options)
    } else {
      api.reload('49493022', component.options)
    }
    module.hot.accept("./401.vue?vue&type=template&id=49493022", function () {
      api.rerender('49493022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/public/error-page/401.vue"
export default component.exports